import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/v2-migration-hero.png")